<template>
  <div class="pa-5">
    <v-card shaped class="elevation-10">
      <v-card-title>{{ `แบบฟอร์ม${form_title}กิจกรรม` }}</v-card-title>      
      <v-card-text>
        <input hidden type="file" accept="image/*" ref="cover_input" @change="cover_change">
				<div class="d-flex justify-center cover-zone" @click="toggle_cover()">
					<img class="img-fluid pa-2" v-if="cover_preview" :src="cover_preview">
					<h4 class="py-10" v-if="!cover_preview">รูปภาพหน้าปก</h4>
				</div>
      </v-card-text>
      <v-card-text class="pt-0">
        <v-text-field v-model="form.name" outlined dense label="ชื่อกิจกรรม"></v-text-field>
        <v-textarea v-model="form.description" dense outlined rows="2" label="รายละเอียดกิจกรรม"></v-textarea>
        <v-file-input 
          v-model="form.images" 
          dense 
          outlined 
          multiple
          prepend-icon=""
          prepend-inner-icon="mdi-image-multiple"
          :label="form_type === 'EDIT' ? 'แนบอัลบั้มใหม่' : 'แนบอัลบั้ม'"
        ></v-file-input>

      </v-card-text>
      <v-card-actions class="d-flex flex-row justify-center">
        <v-btn color="success" @click="submit" :disabled="!validate_form">บันทึก</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  data: () => ({
    form: {
      name: '',
      description: '',
      cover: null,
      images: []
    },
    cover_preview: null
  }),
  computed: {
    form_type() { return this.$route.meta.form_type },
    form_title() { return this.$route.meta.form_title },
    validate_form() {
      return this.form.name !== '' &&
        this.form.cover !== null
    }
  },
  mounted() {
    if(this.form_type === 'EDIT') {
      this.$store.dispatch('activity/edit', this.$route.params.id)
        .then(resp => {
          this.form = {
            id: resp.id,
            description: resp.description,
            name: resp.name
          }

          if(resp.cover_path) {
            this.cover_preview = `${process.env.VUE_APP_URL}/storage/activities/covers/${resp.cover_path}`;
          }
        });        
    }
  },
  methods: {
    toggle_cover() { this.$refs.cover_input.click(); },
    cover_change(event) {
      const files = event.target.files || event.dataTransfer.files;

			if(!files.length) { 
				return; 
			} else {
				this.cover_preview = URL.createObjectURL(files[0]);
				this.form.cover = files[0];
			}      
    },
    submit() {
      this.$store.dispatch(`${this.form_type === 'CREATE' ? 'activity/store' : 'activity/update'}`, this.createFormData(this.form)).then(() => {
        this.$router.push({ name: 'ActivityList' });
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'success',
          message: 'บันทึกข้อมูลสำเร็จ'
        });
      }).catch(() => {
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'error',
          message: 'เกิดข้อผิดพลาดบางอย่าง'
        });
      });
    },
		createFormData(form) {
      let formData = new FormData;
      
      if(form.id) {
        formData.append('id', form.id);
      }

      formData.append('name', form.name);
      formData.append('description', form.description);
      formData.append('cover', form.cover);
      
      if(form.images) {
        form.images.forEach(item => {
          formData.append('images[]', item);
        });
      }
      
			return formData;
    }
  }
}
</script>

<style lang="scss">
  .cover-zone {
    border: 2px dashed;
    cursor: pointer;
  }
  .img-fluid {
    width: 100%;
  }
</style>